import { ReactComponent as KlabLogo } from '../../assets/logos/klabLogo.svg';
import Center from '../core/components/center';

const SplashPage: React.FC = () => {
  return (
    <Center>
      <KlabLogo width={200} height={100}></KlabLogo>
    </Center>
  );
};

export default SplashPage;
